import { Provider } from '@angular/core';

import { PublicationUseCasesImpl } from '@app/domain/use-cases/multimedia/publication/publication.use-cases';
import { PUBLICATION_USE_CASES } from '@app/domain/use-cases/multimedia/publication/publication.use-cases.contract';

export const publicationUseCasesProvider: Provider = {
  provide: PUBLICATION_USE_CASES,
  useClass: PublicationUseCasesImpl
};
